import { getData, mhandHttps } from "./utils.js";
import { createCard } from "./createCard.js";
import { productCardAnimations } from "./animations/productCardAnimations.js";

async function loadAndRenderCards(container, endpoint) {
    if (container) {
        const fragment = document.createDocumentFragment();

        try {
            const data = await getData(`${mhandHttps}${endpoint}`);
            const promises = data.results.map(async (info) => {
                const card = await createCard(info);
                fragment.appendChild(card);
            });

            await Promise.all(promises);
            container.appendChild(fragment);
            productCardAnimations(container);
        } catch (error) {
            console.error('Error loading products:', error);
        }
    }
}

export function createProductCard() {
    const mainSection = document.querySelector('.main-products-section__container');
    const newProductSection = document.querySelector('.offered-products-section__container');

    loadAndRenderCards(mainSection, 'api/products/');

    loadAndRenderCards(newProductSection, 'api/products/?is_new=1');
}